module.exports = __webpack_public_path__ + "img/50.58f2b2c6.png";